import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { space, SpaceProps } from 'styled-system';

const modalColor = theme('mode', {
  light: (props: any) => props.theme.colors.ghostBlock,
  dark: (props: any) => props.theme.colors.ghostBlock,
});

const backgroundColor = theme('mode', {
  light: (props: any) => props.theme.colors.solitude,
  dark: (props: any) => props.theme.colors.navy,
});

const ModalWrapper = styled(Flex)`
  position: absolute;
  background-color: ${modalColor};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  justify-content: center;
  align-items: center;
`;

const ModalInner = styled(Box)<SpaceProps>`
  max-height: 800px;
  min-width: 400px;
  max-width: 900px;
  background-color: ${backgroundColor};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: ${(props) => props.theme.radius.large};
  width: 100%;
  padding: 32px;
  ${space}
`;

export {
  ModalWrapper,
  ModalInner,
};
